import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component/src/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyAuditLogRightSidebar = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-audit-log-right-sidebar" */ './AuditLogRightSidebar.tsx'
		).then((m) => m.AuditLogRightSidebar),
	{ ssr: false },
);

function AsyncAuditLogRightSidebarInner(): React.JSX.Element {
	return (
		<JSErrorBoundary
			id="audit-log-right-sidebar"
			packageName="jiraAdminPagesAuditLogs"
			teamName="Audit-Log Platform"
			sendToPrivacyUnsafeSplunk
		>
			<Placeholder name="async-audit-log-right-sidebar" fallback={<></>}>
				<LazyAuditLogRightSidebar />
			</Placeholder>
		</JSErrorBoundary>
	);
}

// Named export matches filename per jira/filename-case rule
export const AuditLogRightSidebarAsync: React.FC<React.RefAttributes<unknown>> = componentWithFG(
	'jira_frontend_eal_admin_audit_log',
	AsyncAuditLogRightSidebarInner,
	() => null,
);
AuditLogRightSidebarAsync.displayName = 'AuditLogRightSidebarAsync';

export default AuditLogRightSidebarAsync;
